import { useState, useEffect } from 'react';
import { Icon } from '@iconify/react';

export default function Collapsible({ title, options, onSelectOption, defaultOptionId, collapsible, setCollapsible }: any) {
  const [isCollapsed, setIsCollapsed] = useState(collapsible);
  const [selectedOptionId, setSelectedOptionId] = useState<number>();

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
    setCollapsible(!isCollapsed)
  };

  const handleOptionClick = (optionId: number) => {
    setSelectedOptionId(optionId);
    const selectedOption = options.find((option: any) => option.id === optionId);
    selectedOption && onSelectOption(selectedOption);
  };

  useEffect(() => {
    if (defaultOptionId) {
      setSelectedOptionId(defaultOptionId);
      const defaultOption = options.find((option: any) => option.id === defaultOptionId);
      defaultOption && onSelectOption(defaultOption);
    }
  }, []);

  return (
    <div style={{ marginBottom: '10px' }}>
      <div
        onClick={toggleCollapse}
        style={{
          backgroundColor: '#F3F3F3',
          padding: '10px',
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'left',
        }} >
        <Icon icon='bi:calendar' style={{ color: '#FFFFFF', backgroundColor: '#000000', fontSize: '38px', padding: '8px' }} />
        <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', marginLeft: '10px' }}>
          <div>
            <span style={{ display: 'block', marginBottom: '-3px' }}>{title}</span>
            {!!(selectedOptionId) &&
              <span style={{ display: 'block', color: '#888', fontSize: '12px' }}>
                {options.find((option: any) => option.id === selectedOptionId).text}
              </span>}
          </div>
          <span>{isCollapsed ? '>' : 'ʌ'}</span>
        </div>

      </div>
      {!isCollapsed && (
        <div style={{ padding: '10px' }}>
          <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
            {options.map((option: any) => (
              <li
                onClick={() => handleOptionClick(option.id)}
                key={option.id}
                style={{
                  padding: '6px',
                  margin: '3px',
                  cursor: 'pointer',
                  borderLeft: '3px solid #ccc',
                  fontWeight: selectedOptionId === option.id ? 'bold' : 'normal'
                }} >
                {option.text}
              </li>))}
          </ul>
        </div>)}
    </div>);
};